/**
 * Created by jacmai on 3/14/2017.
 */
define(["marionette", "messaging/messenger", "./apiRequestItemView"], function (
  Marionette,
  Messenger,
  ApiRequestItemView,
) {
  var ApiRequestItemController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "apirequestitem";
    },
    show: function (apiRequestItem) {
      this.actionItem = apiRequestItem;
      //attach the apis collection to the model
      apiRequestItem.apis = Messenger.reqres.request("action:apis");
      apiRequestItem.variables = Messenger.reqres.request("action:all:variables");
      //if the request Item is new without an assigned API, assign it the first API from the list, if there are any
      if (
        apiRequestItem.isNew() &&
        apiRequestItem.get("apiId") <= 0 &&
        apiRequestItem.apis.length > 0
      ) {
        apiRequestItem.set("apiId", apiRequestItem.apis.at(0).id);
      }
      this.view = new ApiRequestItemView.apiRequestView({ model: apiRequestItem });

      //handle validation errors
      apiRequestItem.on(
        "invalid",
        function (model, error) {
          this.view.clearErrors();
          if ("apiId" in error) {
            this.view.apiError(error["apiId"]);
          }
          if ("path" in error) {
            this.view.pathError(error["path"]);
          }
          if ("requestBody" in error) {
            this.view.requestBodyError(error["requestBody"]);
          }
        },
        this,
      );

      this.showRegion(this.view);
    },
    getActionItem: function () {
      return this.actionItem;
    },
    isValid: function (callback, context) {
      var variables = Messenger.reqres.request("action:all:variables");
      //collect the config from the view, apply to the model, then validate
      this.actionItem.setRequestPath(this.view.getRequestPath(), variables);
      this.actionItem.setRequestBody(this.view.getRequestBody(), variables);
      if (this.actionItem.isValid()) {
        callback.apply(context);
      }
    },
  });

  return ApiRequestItemController;
});
